import { render, staticRenderFns } from "./IconBars.vue?vue&type=template&id=fa1c28e6&scoped=true&"
import script from "./IconBars.vue?vue&type=script&lang=js&"
export * from "./IconBars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa1c28e6",
  null
  
)

export default component.exports